/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import RebookingTableContainer from 'reports/BookingsReport/RebookingTable';
import HeaderMenu from 'reports/Common/HeaderMenu';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import ReportTableContainer from 'reports/Common/ReportTable';
import { Tables } from 'reports/consts';
import {
  convertOriginGroupAppointmentsToTable,
  convertStatusGroupAppointmentsToTable,
  convertUtmGroupAppointmentsToTable,
} from 'reports/utils';

const ReportsProps = ['appointmentsReport', 'rebookingReport'];

class BookingsLayout extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: 'Bookings',
        items: [
          {
            id: Tables.BookingsByOrigin,
            name: 'by Origin',
            onClick: () => {
              this.setTables(Tables.BookingsByOrigin);
            },
          },
          {
            id: Tables.BookingsByStatus,
            name: 'by Status',
            onClick: () => {
              this.setTables(Tables.BookingsByStatus);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.setTables(Tables.BookingsByOrigin);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const currencyAbbr = this.props.currency;

    return (
      <div className="has-protipbox bookings">
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          <HeaderMenu data={this.state.headerData} selectedId={this.state.shownTables} />
          {this.checkIfAllDataIsLoaded() && (
            <div className="box">
              <div className="title">{`${this.state.title}`}</div>
              {!!(this.state.shownTables & Tables.BookingsByOrigin) && (
                <div id="bookings-by-origin">
                  <ReportTableContainer
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    title="Bookings by Origin"
                    data={{
                      rows: convertOriginGroupAppointmentsToTable(
                        this.props.appointmentsReport.lastRequestResponse.origin_group,
                        currencyAbbr,
                      ),
                    }}
                  />
                </div>
              )}
              {!!(this.state.shownTables & Tables.BookingsByOrigin) && (
                <div id="online-bookings-by-origin">
                  <ReportTableContainer
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    title="Online Bookings by Origin (valid from 1st September 2021)"
                    data={{
                      rows: convertUtmGroupAppointmentsToTable(
                        this.props.appointmentsReport.lastRequestResponse.utm_group,
                      ),
                    }}
                  />
                </div>
              )}
              {this.props.appointmentsReport.lastRequestResponse &&
                !!(this.state.shownTables & Tables.BookingsByStatus) && (
                  <div id="bookings-by-status">
                    <ReportTableContainer
                      startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                      endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                      title="Bookings by Status"
                      data={{
                        rows: convertStatusGroupAppointmentsToTable(
                          this.props.appointmentsReport.lastRequestResponse.status_group,
                          currencyAbbr,
                        ),
                      }}
                    />
                  </div>
                )}
              {this.props.rebookingReport.lastRequestResponse && !!(this.state.shownTables & Tables.RebookingRate) && (
                <div className="box">
                  <div className="title">{`${this.state.title}`}</div>
                  <RebookingTableContainer
                    startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                    endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                    data={this.props.rebookingReport.lastRequestResponse}
                    stylistList={this.props.stylistList}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
  } = state;
  const { uniqueVisitsReport, appointmentsReport, rebookingReport, salonVatRate, isFetching } = reports;
  const currency = selectCurrentSalonCurrency(state);

  return {
    uniqueVisitsReport,
    salonId,
    stylistList,
    appointmentsReport,
    rebookingReport,
    salonVatRate,
    isFetching,
    currency,
  };
};

const BookingsLayoutHoc = connect(mapStateToProps)(BookingsLayout);

export default BookingsLayoutHoc;
